export default () => ({
  advisories: (target, settings) => new jweather.UI.Advisories(target, settings),
  archiveData: (target, settings) => new jweather.UI.ArchiveData(target, settings),
  basicGraph: (target, settings) => new jweather.UI.Graph(target, settings),
  cosmos: (taget, uiSettings, mapSettings) =>
    new jweather.UI.Cosmos(taget, uiSettings, mapSettings),
  currentConditions: (target, settings) => new jweather.UI.CurrentConditions(target, settings),
  // proForecast: (target, settings) => new jweather.UI.DailyBriefing(target, settings),
  forecastTable: (target, settings) => new jweather.UI.FxTable(target, settings),
  markerBuilder: (settings) => new jweather.UI.MarkerBuilder(settings),
  marineForecast: (target, settings) => new jweather.UI.MarineForecast(target, settings),
  modelSelector: (target, settings) => new jweather.UI.ModelSelector(target, settings),
  onsiteReportsList: (target, settings) => new jweather.UI.OnsiteReportsList(target, settings),
  spotList: (target, settings) => new jweather.UI.SpotList(target, settings),
  stats: (target, settings) => new jweather.UI.Stats(target, settings),
  stationMetaData: (target, settings) => new jweather.UI.StationMetadata(target, settings),
  windbow: (target, settings) => new jweather.UI.Windbow(target, settings)
})